var _path, _g, _g2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgDelv = ({
  title,
  titleId,
  ...props
}, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 1534 560",
  ref: ref,
  "aria-labelledby": titleId
}, props), title ? /*#__PURE__*/React.createElement("title", {
  id: titleId
}, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#c1dcaf",
  d: "m46 473v-97h124v97z"
})), _g || (_g = /*#__PURE__*/React.createElement("g", {
  fill: "#757374"
}, /*#__PURE__*/React.createElement("path", {
  d: "m473 45h316v98h-191v68h149v94h-149v71h189v97h-314z"
}), /*#__PURE__*/React.createElement("path", {
  d: "m840 45h125v331h176v97h-301z"
}), /*#__PURE__*/React.createElement("path", {
  d: "m1095 45h134l81 331h11l77-331h134l-135 428h-166z"
}))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
  fill: "#23a538"
}, /*#__PURE__*/React.createElement("path", {
  d: "m1 98h124l1-98h-125z"
}), /*#__PURE__*/React.createElement("path", {
  d: "m423 547v12h-378v-12"
}), /*#__PURE__*/React.createElement("path", {
  d: "m46 143h124v233h-124z"
}), /*#__PURE__*/React.createElement("path", {
  d: "m170 45c0 40.2 0 44.5 0 98 0 0.1 42.7 0 43 0 8.1 0 29 2.2 43.2 11.5 40.7 26.4 41 79.4 41 104.8 0 24.6-0.7 80.6-41 105.7-13.7 8.5-35.1 11-43.2 11-11.1 0-43-0.1-43 0 0 51.4 0 97 0 97 16.2 0 33.7 0 62 0 72.8 0 192-39 192-214 0-175.7-119.2-214-192-214 0 0-62-0.5-62 0z"
}))));
const ForwardRef = /*#__PURE__*/forwardRef(SvgDelv);
export default ForwardRef;